import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect } from "react"

import { useGeolocated } from "react-geolocated"
import { Context } from "../../.."
import { StorageKeys } from "../../../core/utils/defaults"

const Geolocator: FC = () => {

  const { store } = useContext(Context)

  const { coords, isGeolocationAvailable, isGeolocationEnabled } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
  })

  const fetchGeo = async () => {
    if (isGeolocationEnabled && coords != undefined) {
      console.log("Geolocation enabled! Search user city...", coords)
    
      localStorage.setItem(StorageKeys.USER_LOCATION, JSON.stringify([coords.latitude, coords.longitude]))
      store.setLocation([coords.latitude, coords.longitude])

      // let ltx = distanceLatLon(coords.latitude, coords.longitude, )
      // console.log(ltx)
    }
  }

  useEffect(() => {
    console.log(coords)
    if (coords != undefined) {
      setTimeout(() => {
        fetchGeo()
      }, 500)
    }
  }, [coords])

  return (
    <></>
  )
}

export default observer(Geolocator)